import { render, staticRenderFns } from "./permissionConfigModal.vue?vue&type=template&id=4344a052&scoped=true"
import script from "./permissionConfigModal.vue?vue&type=script&lang=js"
export * from "./permissionConfigModal.vue?vue&type=script&lang=js"
import style0 from "./permissionConfigModal.vue?vue&type=style&index=0&id=4344a052&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4344a052",
  null
  
)

export default component.exports